export const COLOR_MODE = {
  LIGHT: 'light',
  DARK: 'dark',
};

export const customerSupportEmail = 'customersupport@keyops.io';
export const surveyInquiryEmail = 'surveyinquiry@keyops.io';
